import { render, staticRenderFns } from "./ModalMessageAssignments.vue?vue&type=template&id=0a78261a&scoped=true"
import script from "./ModalMessageAssignments.vue?vue&type=script&lang=js"
export * from "./ModalMessageAssignments.vue?vue&type=script&lang=js"
import style0 from "./ModalMessageAssignments.vue?vue&type=style&index=0&id=0a78261a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a78261a",
  null
  
)

export default component.exports